(function () {
  if (window.__vioranCenteredAtcScroll) return;
  window.__vioranCenteredAtcScroll = true;

  var buttonSelector = '[data-atc-button], .product-form__submit';
  var animationFrame = 0;

  function isVisible(element) {
    if (!element || element.closest('sticky-atc')) return false;

    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      rect.width > 0 &&
      rect.height > 0 &&
      !element.closest('[hidden], [aria-hidden="true"]')
    );
  }

  function findAddToCartButton() {
    var buttons = document.querySelectorAll(buttonSelector);

    for (var index = 0; index < buttons.length; index += 1) {
      if (isVisible(buttons[index])) return buttons[index];
    }

    return null;
  }

  function centeredScrollPosition(button) {
    var rect = button.getBoundingClientRect();
    var position = window.scrollY + rect.top + rect.height / 2 - window.innerHeight / 2;
    var maximum = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);

    return Math.min(maximum, Math.max(0, position));
  }

  function scrollToAddToCart() {
    var button = findAddToCartButton();
    if (!button) return false;

    if (animationFrame) window.cancelAnimationFrame(animationFrame);

    var start = window.scrollY;
    var destination = centeredScrollPosition(button);
    var distance = destination - start;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || Math.abs(distance) < 2) {
      window.scrollTo(0, destination);
      return true;
    }

    var duration = Math.min(700, Math.max(350, Math.abs(distance) * 0.45));
    var startTime = performance.now();

    function animate(now) {
      var progress = Math.min(1, (now - startTime) / duration);
      var eased = progress < 0.5
        ? 2 * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 2) / 2;

      window.scrollTo(0, start + distance * eased);

      if (progress < 1) {
        animationFrame = window.requestAnimationFrame(animate);
      } else {
        animationFrame = 0;
        window.scrollTo(0, centeredScrollPosition(button));
      }
    }

    animationFrame = window.requestAnimationFrame(animate);
    return true;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-scroll-to-atc]');
    if (!trigger || trigger.getAttribute('aria-disabled') === 'true' || trigger.disabled) return;

    event.preventDefault();
    scrollToAddToCart();
  });

  window.VioranCenteredAtcScroll = {
    findButton: findAddToCartButton,
    scroll: scrollToAddToCart
  };
})();
